"use strict";

export default {
  ersatz: "8e1ba561-e973-4363-97a2-67e35ea7487f",
  vorgesehen: "10a0fe02-9bb7-4fbf-97d3-350ca2cef8f5",
  nichtVorgesehen: "61d7fa0b-e610-471c-bc9a-ba74cb9a95b2"
};
